import React, { useState, useEffect, useContext } from 'react'
import { Form, Typography, Button, Result } from 'antd'
import { useHistory } from 'react-router-dom';
import { appContext } from "../../AppContext";
//Utill fields
import SubmitButton from './../../Utils/SubmitButton';
import InputField from './../../Utils/InputField';
import PasswordField from './../../Utils/PasswordField';
//Hooks
import { useTranslation } from 'react-i18next'
import { useErrorMessage } from './../../Utils/Hooks/useErrorMessage'
import { useFetch } from './../../Utils/Hooks/useFetch'
import { useFormLayout } from './../../Utils/Hooks/useFormLayout'
import { LockOutlined } from "@ant-design/icons";

import ExternalLogins from './ExternalLogins';
import PasswordLogin from './PasswordLogin';

const { Text, Title } = Typography;
const size = "large"

export default function LoginBody(props) {
    const [appState, appDispatch] = useContext(appContext);
    const layout = useFormLayout(size, "vertical");
    const { t } = useTranslation(['login'])
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true);
    const [urlLoading, setUrlLoading] = useState(true);
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [isExternalLoginLoading, setIsExternalLoginLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useErrorMessage('')
    const [passwordOpened, setPassWordOpened] = useState(false)

    const [needChangePassword, setNeedChangePassword] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState();
    const [isPasswordValidated, setIsPassWordValidated] = useState(false)

    const [doFetch, FetchType] = useFetch();

    const applicationName = getApplicationName();

    useEffect(() => {
        const currentReturnUrl = new URLSearchParams(window.location.search).get("ReturnUrl")

        if (currentReturnUrl !== null) {
            // history.replace("/")
            appDispatch({ type: "SETRETURNURL", payload: currentReturnUrl })
        }
        setUrlLoading(false);
    }, // eslint-disable-next-line 
        [])

    useEffect(() => {
        if (!urlLoading && !isExternalLoginLoading) {
            setIsLoading(false);
        }
    },
        // eslint-disable-next-line 
        [props.isLoading, urlLoading, isExternalLoginLoading])

    if(!appState.returnUrl) {
        return (
        <>
            <Result
                status="404"
                title={t("login.noReturnUrl.title")}
                subTitle={t("login.noReturnUrl.subTitle")}
                extra={<a href={appState.myPrequestUrl}>{t("login.noReturnUrl.linkText")}</a>}
            />
        </>
        )

    }

    return (
        <div style={{ paddingBottom: 24 }}>
            {!needChangePassword ? 
            <>
                <Title level={1} >{applicationName !== undefined ? t("login.loginto") + applicationName : t("login.login")}</Title>
                <Form
                    {...layout}
                    name="basic"
                    onFinish={onSubmitClick}
                >

                    <ExternalLogins
                        returnUrl={appState.returnUrl} 
                        setIsExternalLoginLoading={setIsExternalLoginLoading}
                    />

                    {!appState.showPasswordLogin && !passwordOpened && 
                        <Button
                        style={{ width: "100%" }}
                        onClick={() => setPassWordOpened(true)}
                        icon={<LockOutlined />}
                        // type='primary'
                        >
                            {t("login.withcredentials")} 
                        </Button> 
                        }
                    {(appState.showPasswordLogin || passwordOpened) && <PasswordLogin 
                        size={size}
                        errorMessage={errorMessage}
                        isLoading={isLoading}
                        isLoggingIn={isLoggingIn}
                    />}
                </Form>
            </> :
            <>
                <Title level={1} >{"Change password"}</Title>
                <Form
                    {...layout}
                    name="basic"
                    onFinish={onClickChangePassword}
                >
                    <InputField
                        size={size}
                        label={t("login.username")}
                        isLoading={isLoading}
                        input='username'
                        disabled={true}
                    />

                    <PasswordField
                        input="password"
                        size={size}
                        label={t("login.password")}
                        isRequired={true}
                        isRequiredText={t("login.passwordRequired")}
                        isLoading={isLoading}
                    />

                    <PasswordField 
                        input="newPassword" 
                        size={size} 
                        label={t("login.newpassword")}      
                        isRequired={true} 
                        isRequiredText={t("login.passwordRequired")} 
                        isLoading={isLoading}
                        setPasswordPolicyTracker={true}
                        validatePassword={validatePassword}/>
                     
                    <PasswordField 
                        input="confirmPassword" 
                        size={size} 
                        label={t("login.confirmPassword")}      
                        isRequired={true} 
                        isRequiredText={t("login.passwordRequired")} 
                        isLoading={isLoading}/> 

                    <SubmitButton 
                        isLoading={isLoading} 
                        isDoingAction={isLoggingIn} 
                        originalText={t("utils:buttons.save")} 
                        loadingText={t("resetPassword.loading")} 
                        size={size}
                        disabled={!isPasswordValidated}
                    />

                    <Text type="danger">{errorMessage}</Text>                    
                </Form>
            </>
            }
        </div>
    );

    function onClickChangePassword(values) {

        if(!isPasswordValidated)
        {
            setErrorMessage("error.password_missing_policies")
            return;
        }
        
        if(values.newPassword !== values.confirmPassword)
        {
            setErrorMessage("error.password_not_the_Same")
            return;
        }

        const body = {
            userName: values.username,
            oldPassword: values.password,
            newPassword: values.newPassword,
        };
        doFetch(`/user/changepassword`, FetchType.POST, body)
            .then((response) => {
                if(response.isSuccess) {
                    window.location = redirectUrl;
                    return;
                }

                setErrorMessage(response.result)
            })
    }

    function validatePassword(value) {
        setIsPassWordValidated(value)
    }


    function onSubmitClick(values) {
        setIsLoggingIn(true)
        const body = {
            userName: values.username,
            password: values.password,
            returnUrl: appState.returnUrl
        };
        doFetch(`/Account/login`, FetchType.POST, body)
            .then((response) => onLoginFetchLoaded(response.isSuccess, response.result))

        function onLoginFetchLoaded(isSuccess, result) {
            if (isSuccess) {
                if(result.needNewPassword) {
                    setIsLoggingIn(false);
                    setNeedChangePassword(true);
                    setRedirectUrl(result.redirectUrl);
                    setErrorMessage(undefined);
                    return;
                }
                window.location = result.redirectUrl;
                setIsLoggingIn(false);
                return;
            }

            setErrorMessage(result);
            setIsLoggingIn(false);
        }
    }

    function getApplicationName() {
        try {
            const url = new URL(appState.returnUrl, window.location);
            return url.searchParams.get("applicationName") || url.searchParams.get("client_id") || undefined;
        } catch (error) {
            return undefined;
        }
    }
}